var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"desc-section"},[_c('LazyHydrate',{attrs:{"when-idle":""}},[_c('ProductTabs',{attrs:{"product":_vm.product,"open-tab":_vm.activeTab},on:{"changeTab":function($event){return _vm.setActiveTab($event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }